export function convertISODateToLocale(
  ISODate: string,
  locale = 'en-GB',
  options?: Intl.DateTimeFormatOptions
) {
  const date = new Date(ISODate);
  return new Intl.DateTimeFormat(locale, options).format(date);
}
